import { render } from "./KeywordsDictionary.vue?vue&type=template&id=7475c69b"
import script from "./KeywordsDictionary.vue?vue&type=script&lang=js"
export * from "./KeywordsDictionary.vue?vue&type=script&lang=js"

import "./KeywordsDictionary.vue?vue&type=style&index=0&id=7475c69b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__